:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._deprecationBox_15a33_7 {
  box-sizing: border-box;
  outline: 3px solid #acafc4; }
  ._deprecationBox_15a33_7 ._bannerLink_15a33_10 {
    color: inherit;
    cursor: pointer;
    text-decoration: underline; }
    ._deprecationBox_15a33_7 ._bannerLink_15a33_10:hover {
      color: inherit; }
  ._deprecationBox_15a33_7 ._deprecationOverlay_15a33_16 {
    background: rgba(255, 255, 255, 0.5);
    height: 100%; }
    ._deprecationBox_15a33_7 ._deprecationOverlay_15a33_16 ._deprecationPattern_15a33_19 {
      background: repeating-linear-gradient(135deg, rgba(0, 6, 36, 0.2), rgba(0, 6, 36, 0.2) 10px, rgba(0, 6, 36, 0.1) 10px, rgba(0, 6, 36, 0.1) 20px);
      height: 100%; }
